var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SerializableObject } from '@openhps/core';
import { VerticalPassage } from './VerticalPassage';
let Elevator = class Elevator extends VerticalPassage {
};
Elevator = __decorate([
    SerializableObject()
], Elevator);
export { Elevator };
//# sourceMappingURL=Elevator.js.map